<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>厂商管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/factory/network">服务网点列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加服务网点</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加服务网点</span>
        <span class="xcx-add left font14" @click="reback()">返回列表</span>
      </div>
      <div class="xcx-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" style="width: 50%">
          <el-form-item label="网点名称：" prop="title">
            <el-col :span="20">
              <el-input placeholder="请填写网点名称" v-model="ruleForm.title"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="地址：" prop="address">
            <el-col :span="20">
              <el-input placeholder="请填写地址" v-model="ruleForm.address"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系人：" prop="contacts">
            <el-col :span="20">
              <el-input placeholder="请填联系人" v-model="ruleForm.contacts"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系方式：" prop="mobile">
            <el-col :span="20">
              <el-input placeholder="请填联系方式" v-model="ruleForm.mobile"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="服务项目：" prop="service">
            <el-col :span="20">
              <el-input placeholder="请填服务项目" v-model="ruleForm.service"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="合作时间：" prop="stime">
            <el-col :span="20">
              <el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.stime" type="date" placeholder="请填合作时间"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="备注：" prop="desc">
            <el-col :span="20">
              <el-input placeholder="请填备注" type="textarea" v-model="ruleForm.desc"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <div style="width: 100%; height: 15px"></div>
            <el-button type="primary" @click="submitForm('ruleForm')" v-if="id">确认修改</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-else>确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: "",
      ruleForm: {
        title: "",
        address: "",
        contacts: "",
        mobile: "",
        stime: "",
        service: "",
        desc: "",
      },
      rules: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        contacts: [{ required: true, message: "请输入", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },

  /**
   * 进入页面加载
   */
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    }
    that.loading = false;
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/branch/edit", { id: that.id }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
        }
      });
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/branch/store";
        if (that.id) {
          formData.id = that.id;
          url = "/branch/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/factory/network");
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 返回
     */
    reback() {
      this.$router.push("/factory/network");
    },
  },
};
</script>
<style>
</style>